import { Button } from 'shared/ui/button';
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from 'shared/ui/dialog';
import { LoadingButton } from 'shared/ui/loading-button';
import * as m from '@paraglide/messages';
interface ConfirmationDialogProps {
  open: boolean;
  onOpen: (open: boolean) => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
  loading?: boolean;
  confirmText?: string;
  cancelText?: string;
}
export default function ConfirmationDialog({
  open,
  onOpen,
  onConfirm,
  title,
  description,
  loading,
  confirmText = m.confirm_dialog_yes(),
  cancelText = m.confirm_dialog_no()
}: ConfirmationDialogProps) {
  return <Dialog open={open} onOpenChange={onOpen} data-sentry-element="Dialog" data-sentry-component="ConfirmationDialog" data-sentry-source-file="confirmation-dialog.tsx">
      <DialogContent className="sm:max-w-[500px]" data-sentry-element="DialogContent" data-sentry-source-file="confirmation-dialog.tsx">
        <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="confirmation-dialog.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="confirmation-dialog.tsx">{title ?? m.confirm_dialog_title()}</DialogTitle>
          <DialogDescription data-sentry-element="DialogDescription" data-sentry-source-file="confirmation-dialog.tsx">{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="confirmation-dialog.tsx">
          <DialogClose asChild data-sentry-element="DialogClose" data-sentry-source-file="confirmation-dialog.tsx">
            <Button type="button" variant="outline" size="sm" data-sentry-element="Button" data-sentry-source-file="confirmation-dialog.tsx">
              {cancelText}
            </Button>
          </DialogClose>
          <LoadingButton className="w-full sm:w-fit" loading={loading ?? false} type="button" onClick={onConfirm} size="sm" data-sentry-element="LoadingButton" data-sentry-source-file="confirmation-dialog.tsx">
            {confirmText}
          </LoadingButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>;
}